export default "__VITE_PUBLIC_ASSET__8d1e6ba2__"